module.exports = __webpack_public_path__ + "static/quest1-slider-50129d97c8c341d317a0bb07aa09d7e3.png";